import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import * as auth from "../../store/ducks/auth.duck";
import { forgotPassword } from "../../crud/auth.crud";
import { useHistory } from "react-router-dom";
import { createFormikValidation } from "../../utils/Utils";
import CustomInput from "../../components/CustomInput";
import styles from "../../../styles/Login.module.css";
import { useAlert } from "../../context/AlertContext";

const EsqueceuSenha = () => {
    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();

    const { showAlert } = useAlert();

    const onSubmit = (values) => {
        setSubmitting(true);

        forgotPassword(values.email)
            .then(() => {
                showAlert({
                    icon: "success",
                    title: "Sucesso!",
                    text: "Se o e-mail existe no sistema, será enviado o código para redefinição de senha.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                });
                history.push(`/esqueceu-senha-codigo?email=${values.email}`);
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setSubmitting(false));
    };

    const getInitialValues = () => {
        return {
            email: "",
        };
    };

    const validate = (values) => {
        let map = new Map();

        map.set("email", "e-mail");

        return createFormikValidation(map, values);
    };

    return (
        <div className={styles.authContainer}>
            <div className={styles.loginContainer}>
                <div className={styles.loginLeft}>
                    <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                    <div className={styles.containerFormCadastro}>
                        <button type="button" className={styles.buttonBack} onClick={() => history.push("/")}>
                            <ArrowBackIosIcon />

                            <p>Recupere sua senha</p>
                        </button>

                        <p className={styles.textoPrimeiroAcesso}>Insira o e-mail vinculado à sua conta para receber o código de recuperação da senha.</p>

                        <Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                                <form noValidate onSubmit={handleSubmit} className={styles.formLoginContainer}>
                                    <div style={{ flex: 1 }}>
                                        <div className={`${styles.formLogin}`}>
                                            <CustomInput placeholder="Insira seu e-mail" required label="E-mail" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} />
                                        </div>
                                    </div>

                                    <div className={`${styles.buttonContainer} ${styles.paddingButton}`}>
                                        <button type="submit" className={styles.buttonLogin} disabled={submitting}>
                                            {!submitting ? "Enviar código" : <div className="icon-loading" />}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className={styles.loginRight}>
                    <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                </div>
            </div>
        </div>
    );
};

export default connect(null, auth.actions)(EsqueceuSenha);
